/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const Q_which_aoe_attack = require('./Q_which_aoe_attack');
const AICalc = require('../AICalc');
const BattleCalc = require('../../BattleCalc');

const Q_how_many_nearby_allies = function (
  actor,
  battleState,
  noAOEAbilitiesCaseNode
) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  const LESS_THAN_TWO = 0;
  const TWO_OR_MORE = 1;

  const DEFINE_NEARBY = 2; // tiles

  // we pass this the _altNode (which should be Q_state_of_best_target), in case the actor has no AOE abilities
  node.branches[LESS_THAN_TWO] = new Q_which_aoe_attack(
    actor,
    battleState,
    noAOEAbilitiesCaseNode
  );
  node.branches[TWO_OR_MORE] = noAOEAbilitiesCaseNode;

  node.query = function (static_target) {
    var _nearbyAllies = AICalc.getNearbyUnits(
      this.actor,
      BattleCalc.getAlliesOfUnit(
        this.actor,
        this.battleState.allUnits,
        false,
        false // don't worry about friendly fire on summons
      ),
      DEFINE_NEARBY
    );
    var _numNearby = _nearbyAllies.length;

    if (_numNearby < 2) {
      return this.branches[LESS_THAN_TWO].query(static_target);
    } else {
      return this.branches[TWO_OR_MORE].query(static_target);
    }
  };

  return node;
};
module.exports = Q_how_many_nearby_allies;
